import {create} from 'zustand';
import type {IAttributeSet} from '../schema';

// TODO: get this data from the server via react-query?
// probably can't until we have the user editor switched over and whatnot
// Then we perhaps just lift this up to a context tree as very little about the user ever changes
// not entirely sure the best route yet

interface AttributeSetsState {
	attributeSets: IAttributeSet[];
	loading: boolean;
	filters: any;
}

export const useAttributeSets = create<AttributeSetsState>()((set) => ({
	attributeSets: [],
	loading: false,
	filters: {},
}));
